import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static outlets = ["shared--ui--modal"]

  declare readonly sharedUiModalOutlet: any

  openCreateModal(event: Event) {
    event.preventDefault()
    this.sharedUiModalOutlet.open()
  }
}
